import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

// Wave-17 Item 1.1 — Register page lazy-loaded (named `Page` export).
export const Route = createFileRoute("/register")({
  validateSearch: (search) => search,
  component: lazyRouteComponent(() => import("@/pages/Register/Page"), "Page"),
});
